import { Link } from "react-router-dom";
import { Bed, Bath, Maximize2 } from "lucide-react";
import { formatPrice } from "../lib/api";

export default function PropertyCard({ p }) {
  return (
    <Link
      to={`/properties/${p.id}`}
      className="group block bg-white card-lift"
      data-testid={`property-card-${p.id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-stone-100">
        <img
          src={p.images?.[0]}
          alt={p.title}
          className="w-full h-full object-cover img-zoom"
          loading="lazy"
        />
        {p.featured && (
          <span className="absolute top-4 left-4 bg-white/95 backdrop-blur text-[#0A0A0A] text-[9px] uppercase tracking-[0.3em] font-medium px-3 py-1.5">
            Featured
          </span>
        )}
        <span
          className={`absolute top-4 right-4 text-[9px] uppercase tracking-[0.3em] font-medium px-3 py-1.5 ${
            p.status === "For Sale"
              ? "bg-white/95 text-[#0A0A0A]"
              : p.status === "Pending"
              ? "bg-amber-100/95 text-amber-900"
              : "bg-stone-200/95 text-stone-700"
          }`}
        >
          {p.status}
        </span>
      </div>
      <div className="pt-6 pb-2">
        <div className="eyebrow text-gray-500 mb-2">
          {p.neighborhood} · {p.property_type}
        </div>
        <h3 className="font-display text-2xl lg:text-[28px] leading-tight text-[#0A0A0A] mb-1">
          {p.title}
        </h3>
        <div className="text-sm text-gray-500 line-clamp-1">
          {p.address}
        </div>
        <div className="flex items-baseline justify-between mt-5 pt-5 border-t border-stone-200">
          <div className="font-display serif-italic text-3xl text-[#E63946]">
            {formatPrice(p.price)}
          </div>
          <div className="flex items-center gap-4 text-xs text-gray-500">
            <span className="flex items-center gap-1.5">
              <Bed className="w-3.5 h-3.5" strokeWidth={1.5} /> {p.beds}
            </span>
            <span className="flex items-center gap-1.5">
              <Bath className="w-3.5 h-3.5" strokeWidth={1.5} /> {p.baths}
            </span>
            <span className="flex items-center gap-1.5">
              <Maximize2 className="w-3.5 h-3.5" strokeWidth={1.5} /> {p.sqft.toLocaleString()}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
